export default __webpack_public_path__ + "static/media/sideMenu_support.752a6e4c.svg";